__webpack_require__.p = "https://assets-01.periodica.press/0fbc80a-22626083304/";